export default __webpack_public_path__ + "static/media/SWT0140.34I-21190_-14882_0.e24ed7e8.jpg";